// removed by extract-text-webpack-plugin
module.exports = {"nav":"style__nav___1QdaZ","link":"style__link___7xp6b","active":"style__active___3Dz60"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoggedLayout/NavigationBar/style.scss
// module id = 2222
// module chunks = 0